
import React, { useState } from 'react';

export const Tooltip = ({ content, children, className = '' }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div
            className={`relative flex items-center ${className}`}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-stone-900 border border-stone-700 text-stone-200 text-xs rounded shadow-xl whitespace-nowrap z-50 pointer-events-none">
                    {content}
                    {/* Arrow */}
                    <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-stone-700" />
                </div>
            )}
        </div>
    );
};
